import { render, staticRenderFns } from "./EditFood.vue?vue&type=template&id=3597234e&scoped=true&"
var script = {}
import style0 from "./EditFood.vue?vue&type=style&index=0&id=3597234e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597234e",
  null
  
)

export default component.exports